import React from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import { parseUTC } from 'core/utils';
import FancyHoverImg from 'core/components/FancyHoverImg';
import {
	Card,
	Title,
	CardDate,
} from './listicleCardStyles';
import { ResponsiveCheck } from 'core/providers/Responsive';

const ListicleCard = ({
	slug, title, image, updatedAt
}) => {
	return (
		<ResponsiveCheck>{({ isDesktop }) => (
			<Card href={`/box-insider/${slug}/`} title={title}>
				<FancyHoverImg
					src={image}
					alt={title}
					width={isDesktop ? "400" : "165"}
					height={isDesktop ? "250" : "100"}
					lazy
				/>
				<Title>{title}</Title>
				<CardDate>{format(parseUTC(updatedAt), 'LLLL yyyy')}</CardDate>
			</Card>
		)}
		</ResponsiveCheck>
	);
};

ListicleCard.propTypes = {
	slug: PropTypes.string,
	title: PropTypes.string,
	image: PropTypes.string,
	updatedAt: PropTypes.string,
};

export default ListicleCard;
